import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { purpurColorGreen100, purpurColorGreen600, purpurColorRed100, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const MessageContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.spacing12};
  border-radius: 4px;
  margin: ${spacing.spacing16} ${spacing.spacing28} 0 ${spacing.spacing28};
  gap: 8px;

  margin: ${({ $hasMargins }) => $hasMargins ? '16px 30px 0 30px' : '16px 0 0 0'};
  background-color: ${({ $type }) => $type === 'success' ? purpurColorGreen100 : purpurColorRed100};
  color: ${({ $type }) => $type === 'success' ? purpurColorGreen600 : purpurColorRed600};
  border: 1px solid ${({ $type }) => $type === 'success' ? purpurColorGreen600 : purpurColorRed600};
`;
const Content = styled.div `
  display: flex;
  align-items: center;
`;
const CloseIcon = styled.div `
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 32px;
  height: 32px;

  &:hover {
    opacity: 0.7;
  }
`;
export const StatusMessage = ({ type = 'error', message, onDismiss, hasMargins = false, }) => (_jsxs(MessageContainer, { "$type": type, "$hasMargins": hasMargins, children: [_jsx(Content, { children: message }), onDismiss && (_jsx(CloseIcon, { onClick: onDismiss, children: _jsx(Icon, { svg: icons.close }) }))] }));
